import { render, staticRenderFns } from "./letter-temp-two.vue?vue&type=template&id=6c8cb45c"
import script from "./letter-temp-two.vue?vue&type=script&lang=ts"
export * from "./letter-temp-two.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports